<template>
  <div class="idtr-block idtr-section">
    <div class="idtr-band">{{ text.statementTitle }}</div>
    <div class="idtr-statement idtr-section__body">
      <field-editable v-model="idtrForm.statement" />
    </div>
  </div>
</template>

<script>
import FieldEditable from "../FieldEditable.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldEditable},
  inject: ["idtrForm"],
  data: () => ({text: IDTR_TEXT}),
};
</script>
